class Api {
  static actionTypeEnum = {
    read: "read",
    update: "update",
    delete: "delete",
  };

  levelId = {};
  isStandAlone = null;
  baseUrl = "";

  constructor(auth) {
    this.levelId = { realm: auth.realm?.id, org: auth.orgs?.id, site: auth.sites?.id };
    this.isStandAlone = this._checkStandAlone();
    this.baseUrl = this._getBaseUrl();

    Api.instance = this;
  }

  static init(auth) {
    Api.instance = null;
    return new Api(auth);
  }

  _checkStandAlone = () => {
    return !this.levelId.org || Object.keys(this.levelId.org).length === 0;
  }

  _getBaseUrl() {
    return this.isStandAlone ? `/orgs/:orgId/sites/:siteId` : `/ents/:entId/orgs/:orgId/sites/:siteId`;
  }

  getRequestParams(method = Api.actionTypeEnum.read, portId = null) {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site, portId } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site, portId };
    let url = `${this.baseUrl}/settings/profilePorts/:portId/profilePorts`;
    let apiKey = "";

    switch (method) {
      case Api.actionTypeEnum.update:
        apiKey = `${url}.update`;
        break;
      case Api.actionTypeEnum.delete:
        apiKey = `${url}.delete`;
        break;
      default:
        break;
    }

    return {
      apiKey,
      params,
    };
  }

  getScheduleRequestParams(method = Api.actionTypeEnum.read) {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/settings/profileSchedule`;
    let apiKey = `${url}.${method}`;

    return {
      apiKey,
      params,
    };
  }

  getRadiusProfileRequestParams(method = Api.actionTypeEnum.read) {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/settings/radiusProfile`;
    let apiKey = `${url}.${method}`;

    return {
      apiKey,
      params,
    };
  }

  getMacProfileRequestParams(method = Api.actionTypeEnum.read) {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/settings/profileMacAddrs`;
    let apiKey = `${url}.${method}`;

    return {
      apiKey,
      params,
    };
  }
}

export default Api;